<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn icon dark title="Back to payroll cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-processing" color="white"></help-link>
                    <v-menu v-if="!loading&&fiscal_years.length>0" left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on" :loading="loading">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`">
                            <v-list-tile :key="0" @click="selectedFiscalYear=item.fiscalYear">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <div v-if="!loading && company_details!=null">
                <v-alert v-if="company_details.workDaysPerWeek==0" :value="true" color="warning" icon="warning" outline style="margin-top:10px;">
                    Company <b>Work Days per Week</b> has not been setup yet. Please update at <span @click="$router.push('/settings/workdays')"><u style="cursor:pointer;"><b>Settings page</b></u></span>
                </v-alert>  
                <v-alert v-if="company_details.workHoursPerDay==0 || company_details.workHoursPerDay==1" :value="true" color="warning" icon="warning" outline style="margin-top:10px;">
                    Company <b>Work Hours per Day</b> has not been setup yet. Please update at <span @click="$router.push('/settings/workdays')"><u style="cursor:pointer;"><b>Settings page</b></u></span>
                </v-alert>
            </div>
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <div style="width:35%">
                        <v-text-field v-model="search" append-icon="search" label="Search Date YYYY-MM-DD format" single-line hide-details style="margin-bottom:15px;"></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="cutoff_periods_filtered"
                    :loading="loading"
                >
                    <template v-slot:items="props">
                        <tr style="cursor:pointer;" @click="viewDetails(props.item)">
                            <td>
                                <span v-if="props.item.cutOffPeriodDesc=='Current'" class="font-weight-bold">{{props.item.cutOffPeriodDesc}}</span>
                                <span v-else>{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td>{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td>{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColorByDesc(props.item.payrollOverallStatus)">{{props.item.payrollOverallStatus}}</span>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import commonfn from '@/common/functions'

export default {     
    name: 'Payroll',
    metaInfo: {
        title: 'Payroll',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, generate payroll' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
      return {
            y: null,
            x: null,
            mode: null,
            error: false,
            errorMessage: '',
            loading: false,
            snackbar: false,
            snackbarText: '',
            headers: [
                    {text: 'Period',align: 'left',value: 'cutoffStart', width: '20%', sortable:false},
                    {text: 'Cutoff Start Date',align: 'left',value: 'cutoffStart', width: '20%', sortable:false},
                    {text: 'Cutoff End Date',align: 'left',value: 'cutoffEnd', width: '20%', sortable:false},
                    {text: 'CutOff Status',align: 'left',value: 'status',  width: '20%', sortable:false},
                    {text: 'Payroll Status',align: 'left',value: '',  width: '20%', sortable:false},
                ],
            search: null,
            cutoff_periods: [],
            serverDate: null,
            company_details: null,
            fiscal_years: [],
            menu_status: false,
            selectedFiscalYear: null,
        }
    },
    methods: {   
        viewDetails(data) {
            if (this.company_details.workDaysPerWeek==0) {
                this.snackbarText = `Please update your work days per week.`
                this.snackbar = true
                return;
            }
            if ( this.company_details.workHoursPerDay==0 || this.company_details.workHoursPerDay==1) {
                this.snackbarText = `Please update your work hours per day.`
                this.snackbar = true
                return;
            }
            //allow generation of payroll for frozen period
            //for closed period, read only view
            if (data.cutOffStatus == commonfn.getStatusCode('Open')) {
                this.snackbarText = `This cutoff period is still open.`
                this.snackbar = true
            }else{
                this.$router.push('/payroll/generate/' + data.cutOffId)
            }
        },
        async getPayollMain() {
            try {
                this.loading = true
                const response = await payrollApi.getMain()
                if (response && response.status == 200) {
                    this.company_details = response.data.company
                    this.fiscal_years = response.data.fiscalYears.reverse()
                    this.cutoff_periods = response.data.cutoffItems
                    this.selectedFiscalYear = this.$moment(new Date).year() //this.fiscal_years[0].fiscalYear
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.commonfn = commonfn

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Processing'
        })

        this.getPayollMain()
    },
    computed: {
        cutoff_periods_filtered() {
            let temp = this.cutoff_periods.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return this.$moment(item.cutOffStart).format('YYYY-MM-DD').includes(this.search) ||
                        this.$moment(item.cutOffEnd).format('YYYY-MM-DD').includes(this.search)
                })
            }
            return temp //.reverse()
        }
    }
}
</script>